import React, { useState, useEffect } from "react"

import { Link, useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./alert.module.scss"
import DarkColor from "../../../helpers/dark-color"
import LogoType from "../../../helpers/logo-type"
import Heading from "../../atoms/heading"
import Icon from "../../atoms/icon"
import Wrapper from "../../atoms/wrapper"

const Alert = ({ content }) => {
  const { partnerPrefix, site, sanityAlert } = useStaticQuery(graphql`
    {
      partnerPrefix: sanityDictionary(
        key: { current: { eq: "partner_feature" } }
      ) {
        value
      }
      site {
        siteMetadata {
          siteUrl
        }
      }
      sanityAlert {
        alerts {
          color
          country {
            url
          }
          partner {
            logo {
              ...ImageWithPreview
            }
            dark_logo {
              ...ImageWithPreview
            }
            name
            prefix
          }
          show_alert
          text
          url
        }
      }
    }
  `)
  const [isClosed, setIsClosed] = useState(true)
  const [alertContent, setAlertContent] = useState({})
  const [isRemoved, setIsRemoved] = useState(false)

  useEffect(() => {
    setAlertContent(
      content ||
        sanityAlert?.alerts.find(
          (alert) =>
            alert.country === null ||
            alert.country.url === site.siteMetadata.siteUrl
        )
    )
  }, [])

  useEffect(() => {
    if (
      (content || !sessionStorage.getItem("alert_prompt")) &&
      alertContent &&
      (alertContent.show_alert || content) &&
      window.location.pathname !==
        `${alertContent.url?.split("?")[0]}${
          alertContent.url?.split("?")[0].endsWith("/") ? "" : "/"
        }` &&
      !window.location.pathname.includes("contest/") &&
      !window.location.pathname.includes("bracket-challenge/")
    ) {
      setIsClosed(false)
      setIsRemoved(false)
    } else {
      setIsRemoved(true)
    }
  }, [alertContent])

  const closeModal = () => {
    setIsClosed(true)
    sessionStorage.setItem("alert_prompt", true)
  }

  return isRemoved ? (
    ""
  ) : (
    <div
      className={`${styles.alert} ${isClosed ? styles.alert__closed : ""} ${
        styles[`alert__${alertContent.color}`]
      }`}
    >
      <Wrapper>
        <Link id="alert-banner" className={styles.link} to={alertContent.url}>
          <Heading className={styles.wrapper} level={6} semantic={false}>
            <div className={styles.content}>
              {alertContent.text}{" "}
              {alertContent.partner ? (
                <>
                  <span className={styles.presented}>
                    {alertContent.partner.prefix || partnerPrefix?.value}
                  </span>
                  {alertContent.partner.dark_logo ||
                  alertContent.partner.logo ? (
                    <Image
                      {...LogoType(
                        DarkColor(alertContent.color),
                        alertContent.partner.logo,
                        alertContent.partner.dark_logo
                      )}
                      width={40}
                      className={styles.logo}
                      alt={alertContent.name}
                    />
                  ) : (
                    alertContent.name
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          </Heading>
        </Link>
      </Wrapper>
      {!content ? (
        <button
          type="button"
          aria-label="Close"
          onClick={closeModal}
          onKeyPress={closeModal}
          className={styles.close}
        >
          <Icon icon="close" />
        </button>
      ) : (
        ""
      )}
    </div>
  )
}

Alert.propTypes = {
  content: PropTypes.object,
}

Alert.defaultProps = {
  content: null,
}

export default Alert
